<div class="app-object-list">
  <ng-container *ngIf="objectMeta && !isLoading">
    <form [id]="formIdent" ngNativeValidate ngNoForm (keydown.enter)="$event.preventDefault()" (submit)="submitForm($event)">
      <div class="layout-auto-1">
        <div class="content" style="max-height: 260px;">
          <table class="display-table">
            <thead role="rowgroup">
            <tr role="row">
              <span class="fixed" style="display: table">
                <th role="columnheader" style="text-align: center" class="table-selector"
                    (click)="addValueRow()" [ngClass]="{'table-disabled': forceDisable, 'table-hover': !forceDisable}">
                  <i class="fa-regular fa-fw fa-plus"></i>
                </th>
              </span>
              <ng-container *ngFor="let header of objectMeta.Headers">
                <th role="columnheader">{{header}}</th>
              </ng-container>
              <span class="fixed" style="display: table">
                    <th role="columnheader" style="text-align: center;" class="table-selector"
                    >{{currentRowCount}}<ng-container *ngIf="objectMeta.MaxRow > -1">/{{objectMeta.MaxRow}}</ng-container>
                    </th>
                  </span>
            </tr>
            </thead>

            <tbody>
            <ng-container>
              <tr role="row" *ngFor="let item of [].constructor(currentRowCount); let i = index">
                    <span class="fixed" style="display: table">
                      <td role="cell" class="table-selector" style="text-align: center; padding: 10px;">
                        <span style="height: 22px">{{i + 1}}</span>
                      </td>
                    </span>
                <ng-container *ngFor="let value of [].constructor(objectMeta.Headers.length); let x = index;">
                  <td role="columnheader" style="min-width: 100px;">
                    <input [type]="objectMeta.Types[x]" [name]="formIdent+i+'.'+x" [id]="formIdent+i+'.'+x"
                           [value]="objValues[i][objectMeta.Headers[x]]" [checked]="isValidBoolean(objValues[i][objectMeta.Headers[x]])"
                           [disabled]="forceDisable"
                           (change)="onInputChange($event.target, i, x)" [required]="objectMeta.Required[x]">
                  </td>
                </ng-container>
                <span class="fixed" style="display: table">
                      <td role="cell" style="text-align: center; padding: 10px;" class="table-selector"
                          (click)="removeValueRow(i)" [ngClass]="{'table-disabled': forceDisable, 'table-hover': !forceDisable}">
                        <i class="fa-regular fa-fw fa-trash"></i>
                      </td>
                    </span>
              </tr>
            </ng-container>
            </tbody>
          </table>
        </div>

        <div class="grid-1-auto" style="margin-top: 0.5rem">
          <div></div>
          <button type="submit" name="submitText" class="md-btn" [disabled]="forceDisable">{{submitText}}</button>
        </div>
      </div>
    </form>
  </ng-container>
</div>
